export type SlotItem = {
  hour: number | string;
  minute: number | string;
};

export type Slot = {
  start: SlotItem;
  end: SlotItem;
};

export type ModifySlot = {
  start: SlotItem;
  end: SlotItem;
  id: number;
  invalidDataError: boolean;
  overlapError: boolean;
};

export type TimeSlot = {
  day: number;
  slots: Slot[];
};

export type ModiFyTimeSlot = {
  day: number;
  slots: ModifySlot[];
};

export type ScheduleFormValues = {
  scheduleName: string;
  timezone: string;
};

export type ScheduleFormErrors = {
  scheduleName: string;
  timezone: string;
};

export type DayLabelMap = {
  label: string;
  day: number;
};

export const SCHEDULE_DAY_ROWS: DayLabelMap[] = [
  { label: 'Monday', day: 1 },
  { label: 'Tuesday', day: 2 },
  { label: 'Wednesday', day: 3 },
  { label: 'Thursday', day: 4 },
  { label: 'Friday', day: 5 },
  { label: 'Saturday', day: 6 },
  { label: 'Sunday', day: 0 },
];

export const WEEKDAY_NUMBERS = [1, 2, 3, 4, 5];

export type ScheduleFormMode = 'create' | 'edit';
